import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { startLoading, endLoading, startSending, endSending } from "../progress/pogressSlice";
import { closeModal } from "../modal/modalSlice";
import { serverErrors } from "../";
import * as api from '../../api'

const initialState = {
    backup: [],
    students: [],
    student: {
        backup: [],
        dataChart: [],
        events: [],
        hours: 0,
        total: 0,
        years: []
    },
    total: 0
}

const dir = 'students';

export const fetchStudents = createAsyncThunk('/students/fetch', async({ cycle }, thunkAPI) => {
    thunkAPI.dispatch(startLoading())
    try {
        const { data } = await api.getData(`${dir}/calendar/${cycle}`)
        thunkAPI.dispatch(endLoading())
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue()
    }
});

export const filterdStudents = createAsyncThunk('/studetns/filterd', async({ career }, thunkAPI) => {
    thunkAPI.dispatch(startLoading())
    try {
        const { data } = await api.getData(`${dir}/career/${career}`)
        thunkAPI.dispatch(endLoading())
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue()
    }
})

export const createStudent = createAsyncThunk('/students/create', async({ values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.createNew(dir, values)
        thunkAPI.dispatch(endSending())
        thunkAPI.dispatch(closeModal())
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue()
    }
})

export const editStudent = createAsyncThunk('/students/edit', async({ id, values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.editData(dir, id, values)
        thunkAPI.dispatch(endSending())
        thunkAPI.dispatch(closeModal())
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue()
    }
})

export const deleteStudents = createAsyncThunk('/students/delete', async({ id }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        await api.deleteItem(dir, id)
        thunkAPI.dispatch(endSending())
        thunkAPI.dispatch(closeModal())
        return id;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending))
        return thunkAPI.rejectWithValue()
    }
});

export const searchStudent = createAsyncThunk('/students/search', async({id, navigate}, thunkAPI) => {
    thunkAPI.dispatch(startLoading());
    try {
        const { data } = await api.getData(`${dir}/${id}`);
        thunkAPI.dispatch(endLoading());
        navigate(`/estudiantes/${id}`)
        return data
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue()
    }
})

export const findStudent = createAsyncThunk('/students/find', async({codigo, setError, navigate}, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        const { data } = await api.getData(`${dir}/find/${codigo}`);
        thunkAPI.dispatch(endSending());
        navigate(`/estudiantes/${codigo}`)
        return data
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue()
    }
})

export const studentsSlice = createSlice({
    name: 'students',
    initialState,
    reducers: {
        clearResult: (state) => initialState,
        filterByDate: (state, action) => {
            if(action.payload)
                state.student.backup = state.student.events.filter(el => el.fecha.includes(action.payload))
            else
                state.student.backup = state.student.events
        },
        filterByCycle: (state, action) => {
            if(action.payload)
                state.backup = state.students.filter(s => s.idCalendario === action.payload)
            else   
                state.backup = state.students;
        },
        filterByCampus: (state, action) => {
            if(action.payload)
                state.backup = state.students.filter(s => s.idCalendario === action.payload.ciclo && s.idSede === action.payload.sede)
            else   
                state.backup = state.students;
        },
        filterBySede: (state, action) => {
            if(action.payload)
                state.backup = state.students.filter(s => s.idSede === action.payload)
            else   
                state.backup = state.students;
        }
    },
    extraReducers(builder){
        builder
            .addCase(createStudent.fulfilled, (state, action) => {
                state.students = [action.payload, ...state.students]
                state.backup = [action.payload, ...state.students]
                state.total = state.total + 1
            })
            .addCase(deleteStudents.fulfilled, (state, action) => {
                state.students = state.students.filter(el => el.id !== action.payload)
                state.backup = state.backup.filter(el => el.id !== action.payload)
                state.total = state.total - 1
            })
            .addCase(editStudent.fulfilled, (state, action) => {
                Object.keys(state.students).forEach(function eachKey(key){
                    if(state.students[key].id === action.payload[0].id){
                        state.students[key] = action.payload[0]
                        return state.backup[key] = action.payload[0]
                    }
                })
            })
            .addMatcher(isAnyOf(findStudent.fulfilled, searchStudent.fulfilled), (state, action) => {
                state.student = { ...action.payload, backup: action.payload.events }
                state.students = action.payload.student
            })
            .addMatcher(isAnyOf(filterdStudents.fulfilled, fetchStudents.fulfilled), (state, action) => {
                state.students = action.payload.students
                state.backup = action.payload.students
                state.total = action.payload?.total || 0
            })
    }
})

export const { clearResult, filterByDate, filterBySede, filterByCycle, filterByCampus } = studentsSlice.actions;

export default studentsSlice.reducer;